<template>
  <div>
    <div style="height: 300px;"/>

      <v-layout justify-center>
        <h1 class="fade-in delay1" style="font-size: 50px;">仮想通貨発行</h1>
      </v-layout>

      <v-layout justify-center>
        <v-card
          class="fade-in delay1"
          color="transparent"
          elevation="0"
          width="800"
        >
          <v-card-text style="font-size: 15px;">
            このページでは、管理者が利用者に対して、仮想通貨を発行する機能をご紹介します。<br/>
            発行された仮想通貨は、拠点で販売されている商品の購入や個人間送金に利用されます。
            ここでは主に「仮想通貨発行機能」と「預り金管理機能」に関する説明をします。
          </v-card-text>
        </v-card>
      </v-layout>

      <div style="height: 400px;"/>

      <div id="issue">
        <v-layout justify-center>
          <h1>仮想通貨発行</h1>
        </v-layout>

        <v-row justify="center">
          <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
            <pics-slider :pics="getPics(pics.issues)"/>

            <slider-dialog :pics="getPics(pics.issues)"/>
          </v-col>

          <v-col align-self="center">
            <v-card
              color="transparent"
              elevation="0"
            >
              <v-card-text style="font-size: 15px;">
                管理者が利用者に対して、現金と引き換えに仮想通貨の発行を行う機能です。
                この機能を利用することで、利用者が仮想通貨を取得し、商品の購買ができるようになります。<br/><br/>

                管理者は管理アプリのコンソールにアクセスし、ナビゲーションバーより「Users / Issue」を選択し、利用者一覧ページを開きます。
                ページを開くと、利用者リストが現れるため、発行行う対象の利用者を選択します。
                利用者数が多い場合、右上の検索バーで名前での検索が利用できます。
                利用者を選択すると、その利用者の詳細情報を記述したダイアログが表示されるため、ダイアログ内左上の紙飛行機アイコンのボタンをクリックします。
                これにより、その利用者に対する仮想通貨発行用のフォームが開きます。<br/><br/>

                仮想通貨発行フォームでは、2つの項目を入力する必要があります。
                1つ目は、利用者のウォレットアドレスです。ウォレットアドレスとは、文字通り「利用者個人の仮想通貨の保管場所に対する宛先」のことで、
                これにより、利用者を指定して仮想通貨を発行することができます。
                アプリでは、この欄は利用者選択時に自動で入力されるので、操作不要です。
                2つ目は、利用者に対して発行する仮想通貨の金額です。
                これは、利用者が仮想通貨と引き換えるために管理者に渡す現金の金額と比例します。
                例えば2000円を受け取った場合であれば、それに相当する金額を入力してください。
                単位を現金に合わせると管理がしやすいので、レートは1：1対応させることをおすすめします。
                フォームが入力できたら、フォーム下の「Issue Token」ボタンを押下し、発行処理を完了させます。<br/><br/>

                以上の操作により、利用者は仮想通貨を受け取り、商品の購入が行えるようになります。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div style="height: 300px;"/>

      <div id="obligation">
        <v-layout justify-center>
          <h1>預り金管理</h1>
        </v-layout>

        <v-row justify="center">
          <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
            <pics-slider :pics="getPics(pics.obligaitons)"/>

            <slider-dialog :pics="getPics(pics.obligaitons)"/>
          </v-col>

          <v-col align-self="center">
            <v-card
              color="transparent"
              elevation="0"
            >
              <v-card-text style="font-size: 15px;">
                管理拠点において、利用者に対して発行した仮想通貨と、利用者から預かった現金を管理する機能です。<br/>
                前セクションの発行機能によって、利用者に対して仮想通貨が発行され、管理拠点には利用者から現金が入ります。
                この現金は即時に管理拠点のものになるのではなく、預り金として一時的に留保されるため、複数拠点での運用の場合、共通口座に入金する必要が出てきます。
                そこで、預り金管理の機能を利用することで、各拠点の預り金の管理を容易に行うことができるようになります。
                この機能では「各月の預り金の閲覧」「現在手元にある預り金の確認」「共通口座への入金手続きの反映」が行えます<br/><br/>

                月毎の預り金は、管理アプリの預り金管理ページをから確認することができます。
                まず、管理アプリのコンソールにアクセスし、ナビゲーションバーより「Money Monagement」=>「Obligation」の順で選択し、預り金管理ページを開きます。
                開いたページの上部に、過去6か月の各月の「預り金額」と「共通口座への入金額」の2つが棒グラフで表示されます。
                これにより管理者は、利用者から預かった現金を月毎に共通口座に入金できているか視覚的に把握することができ、一時留保金の管理のミスを減らすことができます。<br/><br/>
                
                さらに棒グラフの上には、所属拠点の現在手元にある預り金の金額が表示されます。
                これを確認することで、現時点で共通の銀行口座に入金しなくてはならない金額がどれくらいあるかを確認することができます。<br/><br/>

                また、上記の様に入金必要額を確認し、共通口座へ入金処理を行った場合、アプリ上にも入金の記録を反映させる必要があります。
                預り金管理ページの右下にあるフローティングボタンをクリックし、表示される入金フォームに金額を入力します。
                入力後、フォーム下の「OK」ボタンを押下すると入金が記録され、現在手元にある預り金の金額が減額されます。
                この処理により、現実の共通口座残高とアプリ上で流通する仮想通貨の金額との整合性を保つことができます。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div style="height: 50px;"/>    
  </div>
</template>

<script>
import scrollToMixin from '../../../mixin/scrollToMixin'
import PicsSlider from '../components/PicsSlider'
import SliderDialog from '../components/SliderDialog.vue';

export default {
  mixins: [scrollToMixin],
  components: {
    PicsSlider,
    SliderDialog,
  },
  data: () => ({
    pics: {
      issues: ["navigation_2.png", "issue_1.png", "issue_2.png", "issue_3.png"],
      obligaitons: ["navigation_2.png", "obligation_1.png", "obligation_2.png"],
    }
  }),
  methods: {
    /**@param {Array<String>} pics */
    getPics: function(pics){
      const img = [];
      pics.map((value) => {
        img.push(require("../../../images/issue/" + value));
      })
      return img;
    }
  }
}
</script>